export class AdditionalReward {
    constructor(reserveId, apy, accurate, mintId) {
        this.reserveId = reserveId;
        this.apy = apy;
        this.accurate = !!accurate;
        this.mintId = mintId;
    }
    getReserveId() {
        return this.reserveId;
    }
    getApy() {
        return this.apy;
    }
    getAccurate() {
        return this.accurate;
    }
    getMintId() {
        return this.mintId;
    }
}
//# sourceMappingURL=AdditionalReward.js.map